export const explore = {
  title: 'Explore DONKEY TRAVEL',
  subtitle: 'Discover trending destinations and popular members',
  stats: {
    title: 'Our Community in Numbers',
    members: 'Active Members',
    countries: 'Countries',
    exchanges: 'Completed Exchanges',
    satisfaction: 'Satisfaction'
  },
  trending: {
    title: 'Trending Destinations',
    subtitle: 'Most popular destinations this month',
    members: 'members',
    properties: 'properties',
    viewAll: 'View all destinations',
    explore: 'Explore'
  },
  newMembers: {
    title: 'New Members This Week',
    subtitle: 'Welcome our newest community members',
    joined: 'Joined',
    viewProfile: 'View profile',
    exchanges: 'exchanges',
    rating: 'Rating',
    contact: 'Contact'
  },
  featured: {
    title: 'Community Favorites',
    subtitle: 'Handpicked by our members',
    exchanges: 'exchanges',
    rating: 'rating',
    discover: 'Discover',
    viewProfile: 'View profile',
    superHost: 'Super Host'
  },
  seasonal: {
    title: 'Seasonal Availability',
    subtitle: 'Find the perfect time for your exchange',
    spring: 'Spring',
    summer: 'Summer',
    autumn: 'Autumn',
    winter: 'Winter',
    available: 'properties available',
    search: 'Search',
  },
  personalized: {
    title: 'Recommended For You',
    subtitle: 'Based on your browsing history and preferences',
    match: 'match',
    seeMore: 'See more recommendations',
    viewAll: 'View all recommendations',
    based: 'Based on your preferences'
  },
  filters: {
    all: 'All',
    beach: 'Beach',
    mountain: 'Mountain',
    city: 'City',
    countryside: 'Countryside',
    luxury: 'Luxury',
    family: 'Family-friendly'
  }
};